export const initPromoactionRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/promoactions",
          name: "promoaction",
          component: () => import("@/pages/manage/promoactions/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/promoactions/:id",
          name: "promoaction-id",
          component: () => import("@/pages/manage/promoactions/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
